export const LOCATION_DATA = [
    {
        region: 'Mallorca: Center',
        areas: [
            {
                area: 'Alaró',
                neighborhoods: [],
            },
            {
                area: 'Algaida',
                neighborhoods: [],
            },
            {
                area: 'Ariany',
                neighborhoods: [],
            },
            {
                area: 'Biniali',
                neighborhoods: [],
            },
            {
                area: 'Binissalem',
                neighborhoods: [],
            },
            {
                area: 'Búger',
                neighborhoods: [],
            },
            {
                area: 'Bunyola',
                neighborhoods: [],
            },
            {
                area: 'Caimari',
                neighborhoods: [],
            },
            {
                area: 'Campanet',
                neighborhoods: [],
            },
            {
                area: 'Inca',
                neighborhoods: [],
            },
            {
                area: 'Lloret de Vista Alegre',
                neighborhoods: [],
            },
            {
                area: 'Lloseta',
                neighborhoods: [],
            },
            {
                area: 'Llubi',
                neighborhoods: [],
            },
            {
                area: 'Mancor del Valle',
                neighborhoods: [],
            },
            {
                area: 'Maria de la Salut',
                neighborhoods: [],
            },
            {
                area: 'Marratxi',
                neighborhoods: ['Sa Cabaneta'],
            },
            {
                area: 'Montuiri',
                neighborhoods: [],
            },
            {
                area: 'Moscarí',
                neighborhoods: [],
            },
            {
                area: 'Orient',
                neighborhoods: [],
            },
            {
                area: 'Palmanyola',
                neighborhoods: [],
            },
            {
                area: 'Pina',
                neighborhoods: [],
            },
            {
                area: 'Porreres',
                neighborhoods: [],
            },
            {
                area: 'Randa',
                neighborhoods: [],
            },
            {
                area: 'Sant Llorenç Des Cardassar',
                neighborhoods: [],
            },
            {
                area: 'Santa Eugenia',
                neighborhoods: [],
            },
            {
                area: 'Santa Maria del Cami',
                neighborhoods: [],
            },
            {
                area: 'Selva',
                neighborhoods: [],
            },
            {
                area: 'Sencelles',
                neighborhoods: [],
            },
            {
                area: 'Sineu',
                neighborhoods: [],
            },
            {
                area: 'Vilafranca de Bonany',
                neighborhoods: [],
            },
        ],
    },
    {
        region: 'Mallorca: North',
        areas: [
            {
                area: 'Alcúdia',
                neighborhoods: ['Alcanada', 'Bonaire', 'Barcarés', 'Manresa', 'Mal Pas', "Platja d'Alcúdia", 'Puerto de Alcudia'],
            },
            {
                area: 'Muro',
                neighborhoods: ['Playa de Muro'],
            },
            {
                area: 'Pollença',
                neighborhoods: ['Cala San Vicente', 'Formentor', 'La Font', 'Porto Pollença'],
            },
            {
                area: 'Sa Pobla',
                neighborhoods: ['Crestatx'],
            },
            {
                area: 'Santa Margalida',
                neighborhoods: ['Can Picafort'],
            },
        ],
    },
    {
        region: 'Mallorca: Southwest',
        areas: [
            {
                area: 'Andratx',
                neighborhoods: ['Andratx Village', 'Cala Llamp', 'Camp de Mar', "Port d'Andratx", "S'Arraco", 'San Telmo'],
            },
            {
                area: 'Calvià',
                neighborhoods: [
                    'Bendinat',
                    'Cala Fornells',
                    'Cala Vinyes',
                    'Calvià Village',
                    'Cas Catala',
                    'Costa d´en Blanes',
                    'Costa de la Calma',
                    'El Toro',
                    'Illetes',
                    'Mardavall',
                    'Nova Santa Ponsa',
                    'Paguera',
                    'Palmanova',
                    'Peguera',
                    'Port Adriano',
                    'Portals Nous',
                    'Portals Vells',
                    'Puerto Portals',
                    'Sa Vinya',
                    'Santa Ponsa',
                    'Sol de Mallorca',
                    'Son Caliu',
                    'Torrenova',
                ],
            },
        ],
    },
    {
        region: 'Mallorca: Northeast',
        areas: [
            {
                area: 'Artà',
                neighborhoods: ['Betlem', 'Colònia de Sant Pere'],
            },
            {
                area: 'Cala Millor',
                neighborhoods: [],
            },
            {
                area: 'Capdepera',
                neighborhoods: ['Cala Mesquida', 'Cala Ratjada', 'Font de Sa Cala'],
            },
            {
                area: 'Son Servera',
                neighborhoods: ['Cala Bona', 'Port Verd'],
            },
        ],
    },
    {
        region: 'Mallorca: West',
        areas: [
            {
                area: 'Banyalbufar',
                neighborhoods: [],
            },
            {
                area: 'Deià',
                neighborhoods: [],
            },
            {
                area: 'Estellencs',
                neighborhoods: [],
            },
            {
                area: 'Port des Canonge',
                neighborhoods: [],
            },
            {
                area: 'Puigpunyent',
                neighborhoods: ['Galilea'],
            },
            {
                area: 'Valldemossa',
                neighborhoods: [],
            },
        ],
    },
    {
        region: 'Mallorca: South',
        areas: [
            {
                area: 'Campos',
                neighborhoods: ['Es Trenc Area', 'Ses Covetes', 'Campos'],
            },
            {
                area: 'Sa Ràpita',
                neighborhoods: [],
            },
            {
                area: 'Llucmajor',
                neighborhoods: [
                    'Badia Grande',
                    'Badia Azul',
                    'Cala Blava',
                    'Cala Pi',
                    'Vallgornera',
                    'Las Palmeras',
                    'Maioris Décima',
                    'Maioris',
                    'Puig de Ros',
                    "S'Arenal",
                    "S'Estanyol",
                    'Sa Torre',
                    'Son Verí',
                    'Son Verí Nou',
                    'Tolleric',
                ],
            },
            {
                area: 'Ses Salines',
                neighborhoods: ['Colònia de Sant Jordi'],
            },
        ],
    },
    {
        region: 'Mallorca: Northwest',
        areas: [
            {
                area: 'Esporles',
                neighborhoods: [],
            },
            {
                area: 'Soller',
                neighborhoods: [],
            },
            {
                area: 'Sóller',
                neighborhoods: ['Puerto de Sóller', 'Sóller'],
            },
        ],
    },
    {
        region: 'Mallorca: East',
        areas: [
            {
                area: 'Felanitx',
                neighborhoods: ['Es Carritxo', 'Portocolom', 'Son Mesquida'],
            },
        ],
    },
    {
        region: 'Mallorca: Southeast',
        areas: [
            {
                area: 'Manacor',
                neighborhoods: [
                    'Cala Magrana',
                    'Cala Anguila',
                    'Cala Mendia',
                    'Cala Murada',
                    'Cala Romantica',
                    'Porto Cristo',
                    'Porto Cristo Novo',
                    'Son Macia',
                ],
            },
            {
                area: 'Alqueria Blanca',
                neighborhoods: [],
            },
            {
                area: 'Santanyí',
                neighborhoods: ["Cala d'Or", 'Cala Figuera', 'Cala Llombards', 'Cala Mondrago', 'Cala Santanyí', 'Calonge', 'Es Llombards', 'Porto Petro'],
            },
        ],
    },
    {
        region: 'Palma / Son Vida',
        areas: [
            {
                area: 'Palma de Mallorca',
                neighborhoods: [
                    'Anchorage',
                    'Arabella Park',
                    'Arenal',
                    'Bonanova',
                    'Cala Major',
                    "Camp d'en Serralta",
                    'Camp Redó',
                    'Can Pastilla',
                    'Ciutat Antigua',
                    'Cort',
                    'El Terreno',
                    'Es Forti',
                    'Establiments',
                    'Foners',
                    'Genova',
                    'Golf Son Muntaner',
                    'La Bonanova',
                    'Porto Pi',
                    'La Calatrava',
                    'La Missio - Mercat',
                    'La Vileta',
                    'Son Rapinya',
                    'Las Avenidas',
                    'Les Maravelles',
                    'Llevant',
                    'La Soledat',
                    'Es Rafal',
                    'Marivent',
                    'Molinar',
                    'Palma Golf',
                    'Palma Oldtown',
                    'Palma Rural',
                    'Paseo Mallorca',
                    'Paseo Marítimo',
                    'Pere Garau',
                    'Playa de Palma',
                    'Plaza Toros',
                    'Portixol',
                    "S'Aranjassa",
                    'San Agustin',
                    'Sant Jaume',
                    'Santa Catalina',
                    'Ses Cadenes',
                    'Son Anglada',
                    'Son Armadams',
                    'Son Dureta',
                    'Son Espanyolet',
                    'Sant Jordi',
                    'Son Ferriol',
                    'Son Oliva',
                    'Son Dameto',
                    'Son Sardina',
                    'Son Vida',
                    'Zona Colegios',
                ],
            },
        ],
    },
    {
        region: 'Ibiza',
        areas: [
            {
                area: 'Eivissa',
                neighborhoods: [
                    'Marina Botafoc',
                    'Centro',
                    'Can Misses',
                    'Figueretes',
                    'Talamanca',
                    "S'Eixample",
                    "Platja d'En Bossa",
                    'Dalt Vila',
                    'La Marina',
                    'Los Molinos',
                    'Jesús',
                    'Roca Llisa',
                    'Can Furnet',
                    'Cap Martinet',
                    'Ca Na Negreta',
                    'Can Ramón',
                ],
            },
            {
                area: 'Sant Antoni de Portmany',
                neighborhoods: ['Sant Rafel de sa Creu', "Sant Mateu d'Albarca", 'Santa Agnés de Corona'],
            },
            {
                area: 'Sant Josep de Sa Talaia',
                neighborhoods: [
                    'Cala Vedella',
                    'Cala Tarida',
                    'Cala Conta',
                    'San Agustín',
                    'Cala de Bou',
                    'Sant Jordi de Ses Salines',
                    'Sant Josep',
                    'Es Cubells',
                ],
            },
            {
                area: 'Santa Eulalia del Río',
                neighborhoods: ['San Carlos', 'Santa Gertrudis', 'Puig Den Valls'],
            },
            {
                area: 'Sant Joan de Labritja',
                neighborhoods: [],
            },
            {
                area: 'Portinax',
                neighborhoods: [],
            },
            {
                area: 'San Vicente',
                neighborhoods: [],
            },
        ],
    },
    {
        region: 'Menorca',
        areas: [
            {
                area: 'Alaior',
                neighborhoods: [],
            },
            {
                area: 'Ciutadella de Menorca',
                neighborhoods: ['Cala Blanca', 'Cala En Bosch', 'Serpentona', 'Cala En Blanes', 'Cala Morell'],
            },
            {
                area: 'Es Castell',
                neighborhoods: [],
            },
            {
                area: 'Es Mercadal',
                neighborhoods: [
                    'Son Parc',
                    "Port d'Addaia",
                    'Playas de Fornells',
                    "Arenal d'en Castell",
                    'Coves Noves',
                    'Fornells',
                    'Na Macaret',
                    'Punta Grossa',
                    'Ses Salines de Fornells',
                ],
            },
            {
                area: 'Es Migjorn Gran',
                neighborhoods: [],
            },
            {
                area: 'Ferreries',
                neighborhoods: [],
            },
            {
                area: 'Maó / Mahon',
                neighborhoods: [
                    'Centre Històric',
                    "Fort de l'Eau",
                    'Tanques del Carme',
                    'Moli des Pla',
                    'Avinguda Menorca',
                    'Sinia Costabella',
                    'Dalt Sant Joan',
                    'Plaça Eivissa',
                    'Ses Vinyes',
                    'Malbuger',
                    'Sant Climent',
                    'Es Canutells',
                    'Cala Llonga',
                    'Sa Mesquida',
                    'Llucmaçanes',
                    'Es Grau',
                    'Sierra Morena',
                ],
            },
        ],
    },
    {
        region: 'Formentera',
        areas: [
            {
                area: 'Formentera',
                neighborhoods: [
                    'Sant Lluis',
                    'El Pilar de la Mola',
                    'Cap de Barbària',
                    'Sant Ferran',
                    'Sant Francesc',
                    'Cala Saona',
                    'Porto-Salè',
                    'La Savina',
                    'Es Pujols',
                ],
            },
        ],
    },
];
